import routeMixin from '@/router/routeMixin'
import globalMixin from '../../globalMixin'
import mixins from 'vue-typed-mixins'
import { PMNDemande, PMNDemande_Reponse, TypeMailPMN } from '@/domain/PMNDemande'
import { PMNDemande_Statut } from '@/domain/PMNDemande_Statut'
import Openable from '@/global/viewmodels/openable'
import { PMNModeleAdmin } from '../pmn-administration/models/PMNModele'
import _ from 'lodash'
import { jsPDF } from 'jspdf'
import { HubConnectionBuilder } from '@microsoft/signalr'
import Configuration from '@/configuration/configuration'
import { Files, ResponseType } from '@/global/requesting/requester'
import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'
import SendMailModel from '@/layout/model/SendMailModel'

export default mixins(routeMixin, globalMixin, mobileTypeMixin).extend({
    data: function() {
        return {
            dialog: new Openable(),
            demandesPMN: [] as PMNDemande[],
            demandeAffichee: null as null | PMNDemande,
            PMNDemandeAfficheeModeleUtilise: null as null | PMNModeleAdmin,
            companyName: '',
            signatureDemandeAffichee: null as null | string,
            dialogMail: new Openable(),
            mail: new SendMailModel(),
            typeMailPMN: TypeMailPMN.MailClassique,
            textDefautMailSucces : "Bonjour,\n\n" +
            "Nous accusons réception de votre commande et vous en remercions.\n\n" +
            "Celle-ci a été traitée ce jour pour une réception dans vos locaux sous 24 à 72h.\n\n" +
            "Si vous n’êtes pas livré dans le délai imparti merci de contacter le service commercial au 01 64 42 59 65 ou par mail commercial@biobank.fr ."
        }
    },
    methods: {
        getAllDemandePMN() {
            this.$loader.go()
            this.$http
                .api(`PMNBiobank/all?codeClient=${this.companyName || ''}`)
                .get()
                .then(x => {
                    this.demandesPMN = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        printDemande(demande: PMNDemande) {
            if (demande.filesToken) {
                this.$http
                    .api(`PMNBiobank/get-fichiers-PMN?token=${demande.filesToken}`, false, ResponseType.Blob)
                    .get()
                    .then(x => {
                        const nom = x.request
                            .getResponseHeader('content-disposition')
                            .split('filename=')[1]
                            .split(';')[0]
                            .replace(/"/g,"")
                        Files.download(nom, x.data)

                        // window.location.href = this.$http.baseUrl + `/PMNBiobank/get-pdf?id=${x.data}`
                        // x.data.blob()
                        //     .then((blob: Blob) => {
                        //         const url = window.URL.createObjectURL(blob);
                        //         const a = document.createElement('a');
                        //         a.style.display = 'none';
                        //         a.href = url;
                        //         // the filename you want
                        //         a.download = 'todo-1.json';
                        //         document.body.appendChild(a);
                        //         a.click();
                        //         window.URL.revokeObjectURL(url);
                        //         alert('your file has downloaded!');
                        //     })
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
            } else {
                this.$http
                    .api(`PMNBiobank/get-url-pdf?id=${demande.id}`)
                    .get()
                    .then(x => {
                        window.location.href = this.$http.baseUrl + `/PMNBiobank/get-pdf?id=${x.data}`
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
            }
        },
        downloadPMNRemisee(typePMN: number){
            this.$http
                    .api(`PMNBiobank/get-url-modele-PMN-remise?typeFichier=${typePMN}&codeClient=${this.companyName}`)
                    .get()
                    .then(x => {
                        window.location.href = this.$http.baseUrl + `/PMNBiobank/get-modele-PMN-remise?token=${x.data}`
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
        },
        changeStatut(demande: PMNDemande, statut: PMNDemande_Statut) {
            this.$http
                .api(`PMNBiobank/change-statut`)
                .post({ id: demande.id, statut: statut })
                .then(() => {
                    this.getAllDemandePMN()
                    this.loadPastilles()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        displayDemandePMN(demande: PMNDemande) {
            this.$http
                .api(`PMNBiobank/get-modele-versionne?id=${demande.pmnModeleId}`)
                .get()
                .then(x => {
                    this.PMNDemandeAfficheeModeleUtilise = x.data
                    this.demandeAffichee = demande
                    this.dialog.open()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
            this.getSignature(demande)
        },
        getSignature(demande: PMNDemande) {
            this.$http
                .api(`PMNBiobank/get-signature?id=${demande.id}`)
                .get()
                .then(x => {
                    this.signatureDemandeAffichee = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        openEnvoiMail(demande: PMNDemande) {
            // this.modalEnvoiMailDemandeReeditionFacture(demande) // OLD version

            this.mail = new SendMailModel()
            this.mail.id = demande.id
            this.mail.mail = demande.userMail;
            this.dialogMail.open()
            this.typeMailPMN = TypeMailPMN.MailClassique
        },
        openEnvoiMailSucces(demande: PMNDemande) {
            // this.modalEnvoiMailDemandeReeditionFacture(demande) // OLD version
console.log(demande)
            this.mail = new SendMailModel()
            this.mail.id = demande.id
            this.mail.mail = demande.userMail;
            this.mail.corps = this.textDefautMailSucces
            this.dialogMail.open()
            this.typeMailPMN = TypeMailPMN.MailSucces
        },
        envoyerMail(mail: SendMailModel) {
            const formData = new FormData()

            if (!mail) return

            formData.append('idPMN', mail.id.toString())
            formData.append('type', this.typeMailPMN.toString())

            if (!mail.mail) {
                this.$swal.toast.error('Aucun mail renseigné.')
                return
            }
            formData.append('mail', mail.mail)

            if (!mail.corps) {
                this.$swal.toast.error('Aucun corps renseigné.')
                return
            }
            formData.append('corps', mail.corps)


            for (const file of mail.files) {
                formData.append('files', file)
            }

            this.$loader.go()

            this.$http
                .api("pmnbiobank/send-mail")
                .post(formData)
                .then(x => {
                    this.$swal.toast.success("Le mail a bien été envoyé.")
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        }
    },
    computed: {
        dicReponses: function(): _.NumericDictionary<PMNDemande_Reponse> {
            if (!this.demandeAffichee) return {}

            return _.chain(this.demandeAffichee.reponses)
                .keyBy(a => a.pmnModele_InputId)
                .value()
        }
    },
    mounted() {
        this.getAllDemandePMN()

        const connection = new HubConnectionBuilder().withUrl(process.env.VUE_APP_API_URL + '/hubs/refresh').build()

        connection.start().then(() => {
            connection.on('RefreshDemandesPMN', () => {
                this.getAllDemandePMN()
            })
        })
    }
})
